import { render, staticRenderFns } from "./wireTransfer.vue?vue&type=template&id=1e72675a&scoped=true&"
import script from "./wireTransfer.vue?vue&type=script&lang=js&"
export * from "./wireTransfer.vue?vue&type=script&lang=js&"
import style0 from "./wireTransfer.vue?vue&type=style&index=0&id=1e72675a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e72675a",
  null
  
)

export default component.exports